import React, { useContext } from "react";
import { Typography } from "@material-ui/core";
import { ButtonLink } from "./ButtonLink";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BrandThemeContext } from "../../contexts/BrandThemeProvider";

const ChatTeaser = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { themeName } = useContext(BrandThemeContext);

  return (
    <Typography color="inherit">
      {themeName === "GGV" ? t("chat.teaser_text_vaxyes") + " " : t("chat.teaser_text")}
      <ButtonLink
        onClick={themeName === "GGV" ? () => window.open(t("chat.teaser_button_url"), '_blank')
                                     : () => history.push({ pathname: `/chat` })}
        color="inherit"
        label={themeName === "GGV" ? t("chat.teaser_button_vaxyes") : t("chat.teaser_button")}
      />
    </Typography>
  );
};

export { ChatTeaser };
